//商务合作链接
export const BusCooperation = "https://summit2026.wxblockchain.com/partnership";
//购票链接
export const BuyTicket = "https://9424105689699.huodongxing.com/event/4864962337700";
export const BuyTicket_cn = "https://9424105689699.huodongxing.com/event/4865379008511";

//成为嘉宾
// export const toSpeaker = "https://tally.so/r/w85AyY"
export const toSpeaker = "https://summit2026.wxblockchain.com/speakerapplication"